import { FormikConfig, FormikErrors } from "formik";

const RE_EMAIL = /^.+@.+$/;
const RE_UPPER = /[A-Z]/;
const RE_NUMERIC = /\d/;
const RE_VERIFY_CODE = /^\d{6}$/;

export type RegisterPayload = {
    email: string;
    password: string;
    confirmPassword: string;
};

export type RegisterFormConfig = FormikConfig<RegisterPayload>;

export const validateRegisterForm: RegisterFormConfig["validate"] = (data) => {
    const errors: FormikErrors<RegisterPayload> = {};

    if (data.email.trim() === "") {
        errors.email = "Email must be provided";
    } else if (!data.email.match(RE_EMAIL)) {
        errors.email = "Invalid email address";
    }

    if (data.password.trim() === "") {
        errors.password = "Password must be provided";
    } else if (
        data.password.length < 8 ||
        !data.password.match(RE_UPPER) ||
        !data.password.match(RE_NUMERIC)
    ) {
        errors.password =
            "Password field must contain 8 characters, 1 number and a uppercase character";
    }

    if (data.confirmPassword !== data.password) {
        errors.confirmPassword = "Passwords must match";
    }

    return errors;
};

export type LoginPayload = {
    email: string;
    password: string;
    rememberMe: boolean;
};

export type LoginFormConfig = FormikConfig<LoginPayload>;

export const validateLoginForm: LoginFormConfig["validate"] = (data) => {
    const errors: FormikErrors<LoginPayload> = {};

    if (data.email.trim() === "") {
        errors.email = "Email must be provided";
    } else if (!data.email.match(RE_EMAIL)) {
        errors.email = "Invalid email address";
    }

    if (data.password.trim() === "") {
        errors.password = "Password must be provided";
    } else if (
        data.password.length < 8 ||
        !data.password.match(RE_UPPER) ||
        !data.password.match(RE_NUMERIC)
    ) {
        errors.password =
            "Password field must contain 8 characters, 1 number and a uppercase character";
    }

    return errors;
};

export type VerifyPayload = {
    verifyCode: string;
};

export type VerifyFormConfig = FormikConfig<VerifyPayload>;

export const validateVerifyForm: VerifyFormConfig["validate"] = (data) => {
    const errors: FormikErrors<VerifyPayload> = {};
    if (!RE_VERIFY_CODE.test(data.verifyCode)) {
        errors.verifyCode = "Invalid verification code";
    }
    return errors;
};

export type PasswordResetPayload = {
    email: string;
};

export type PasswordResetFormConfig = FormikConfig<PasswordResetPayload>;

export const validatePasswordResetForm: PasswordResetFormConfig["validate"] = (data) => {
    const errors: FormikErrors<PasswordResetPayload> = {};
    if (!RE_EMAIL.test(data.email)) {
        errors.email = "Invalid email address";
    }
    return errors;
};

export const setFirebaseFormikErrors = (error, helpers) => {
    switch (error.code) {
        case "auth/invalid-email":
        case "auth/invalid-credential":
        case "auth/internal-error":
        case "auth/email-already-in-use":
        case "bippit/permission-denied":
            helpers.setFieldError("email", "Invalid email or password");
            break;
        case "auth/missing-password":
            helpers.setFieldError("password", "Password must be provided");
            break;
        case "auth/weak-password":
            helpers.setFieldError(
                "password",
                "Password field must contain 8 characters, 1 number and a uppercase character",
            );
            break;
        default:
            helpers.setFieldError("email", error.code);
            break;
    }
};
